import { screeningEventApi } from '../../apis';

export const fetchScreeningEvents = (sourceId: string) => {
  return screeningEventApi.getScreeningEvents({ sourceId: sourceId });
};
